<div class="content">
    <p>
        Beach grades provide a long-term assessment of how suitable a site is for swimming. The grades are based on the microbial water quality and a risk assessment of potential pollution sources. Swimming sites are graded following the National Health and Medical Research Council’s 2008 Guidelines for Managing Risks in Recreational Waters.
    </p>
</div>
